import { safeLocalStorage } from '@ifixit/utils';

/**
 * The crop dialog this browser last switched to through the banner in
 * either dialog. It outranks the crop-dialog-fit flag, which only picks the
 * dialog for someone who never switched.
 */
type CropDialogChoice = 'new' | 'old';

const STORAGE_KEY = 'cropDialogChoice';

export function chosenCropDialog(): CropDialogChoice | null {
   const choice = safeLocalStorage.getItem(STORAGE_KEY);
   return choice === 'new' || choice === 'old' ? choice : null;
}

/** Call from the banner's click handler: it also counts the switch. */
export function switchCropDialog(choice: CropDialogChoice): void {
   safeLocalStorage.setItem(STORAGE_KEY, choice);
   // Loaded on demand: image_crop.js imports this module on every guide,
   // device and answers page.
   void import('@ifixit/analytics').then(({ trackAnalyticsCustomEvent }) =>
      trackAnalyticsCustomEvent({
         eventCategory: 'Crop Dialog',
         eventAction: 'Crop Dialog - Switch',
         eventName: choice,
      })
   );
}
